module.exports = __webpack_public_path__ + "media/audio12.69b0c417.mp3";